/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

export const Border = () => (
	<svg
		width="285"
		height="160"
		viewBox="0 0 285 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_998_12908)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M183.987 75.1685H102V60.5151H183.987V75.1685Z"
				fill="#82B536"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M183.987 110.337H102V86.8912H183.987V110.337Z"
				fill="#82B536"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M183.987 75.1681H102V60.5147H183.987V75.1681Z"
				fill="#FCA700"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M183.987 48.792H102V40H183.987V48.792Z"
				fill="#1868DB"
			/>
			<path
				d="M96.023 117.579C93.5252 117.776 93.4595 119.617 95.9572 119.798C99.4902 120.061 103.188 120.192 107.969 120.192C113.392 120.093 114.74 119.699 118.404 119.732C124.599 119.716 135.05 120.192 137.564 120.307C137.942 120.324 138.304 120.324 138.682 120.307C141.344 120.225 153.044 119.913 163.133 120.011C170.249 119.978 174.652 119.962 176.953 119.962C182.392 119.929 186.435 119.732 190.411 119.37C192.597 119.173 192.498 117.579 190.296 117.399C186.303 117.07 182.244 116.889 176.822 116.889C174.718 116.889 170.314 116.478 164.119 116.413C163.117 116.413 162.098 116.445 161.112 116.511C152.501 117.136 141.278 117.004 141.278 117.004C141.278 117.004 124.55 117.053 117.484 117.07C112.16 117.086 109.613 117.103 108.035 117.103C103.27 117.136 99.5724 117.284 96.023 117.579Z"
				fill="var(--color-gestural-line)"
			/>
		</g>
		<defs>
			<clipPath id="clip0_998_12908">
				<rect width="285" height="160" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
